@if (!processing) {
  <div ngbDropdown class="d-inline-block text-nowrap">
    <button id="actionDropdown" class="btn btn-secondary" ngbDropdownToggle>Select Action</button>
    <div ngbDropdownMenu aria-labelledby="actionDropdown">
      <a class="dropdown-item" routerLink="/capture-admin/client-management/clients/{{client.id}}/edit">
        Edit Client
      </a>
      @if (canManageClientConfigurations) {
        <a
          class="dropdown-item"
          routerLink="/capture-admin/client-management/clients/{{client.id}}/edit-configuration-options"
          >
          Edit Config
        </a>
      }
      @if (!canManageClientConfigurations) {
        <a
          class="dropdown-item"
          routerLink="/capture-admin/client-management/clients/{{client.id}}/configuration-options"
          >
          Show Config
        </a>
      }
      <a class="dropdown-item"
        href="#viewPortal"
        (click)="onViewPortalClick($event)">
        View Portal
      </a>
      <a class="dropdown-item" routerLink="/capture-admin/client-management/clients/{{client.id}}/change-log">
        View Change Log
      </a>
      @if (client.status === clientStatuses.active) {
        <a
          class="dropdown-item"
          href="#deactivate"
          (click)="onDeactivateClick($event)">
          Deactivate
        </a>
      }
      @if (client.status === clientStatuses.deactivated) {
        <a
          class="dropdown-item"
          href="#reactivate"
          (click)="onReactivateClick($event)">
          Reactivate
        </a>
      }
    </div>
  </div>
} @else {
  <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" /> Processing...
}
